import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Dialog, Divider, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import ProgressIndicatorContainer from "components/ProgressIndicatorContainer";
import { DiagnosticDetailsForm } from "components/AlertsManagement/Case/form/DiagnosticDetailsForm";
import { diagnosticValidation } from "components/AlertsManagement/Case/form/diagnosticValidationSchema";
import { CaseDetailsForm } from "components/AlertsManagement/Case/form/CaseDetailsForm";
import { END_OF_TODAY_DATE } from "core/date-helpers";

const validationSchema = Yup.object({
  open_date: Yup.date()
    .max(END_OF_TODAY_DATE, "Open Date cannot be later than the current date")
    .label("Open Date")
    .typeError("Open Date must be a valid date"),
  component: Yup.object()
    .label("Component")
    .required()
    .nullable(),
  description: Yup.string()
    .label("Description")
    .required()
    .nullable(),
  diagnostic: diagnosticValidation
});

export const CaseFormDialog = ({
  open,
  initialValues,
  onClose,
  loading,
  error,
  onSubmit = () => {},
  ...rest
}) => {
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={onClose}
      aria-labelledby="alarm-trend-slide-title"
    >
      <DialogTitle>Create new case from alert</DialogTitle>
      <form onSubmit={formik.handleSubmit} noValidate>
        <DialogContent sx={{ pt: 0 }}>
          <CaseDetailsForm formik={formik} {...rest} />

          <Divider role="presentation" sx={{ my: 2 }} />

          <DiagnosticDetailsForm formik={formik} />

          <DialogActions sx={{ p: 0, mt: 2 }}>
            <ProgressIndicatorContainer loading={loading}>
              {error && (
                <Typography color="error">
                  An error occurred while creating the case, please try again
                </Typography>
              )}

              <Button variant="outlined" color="primary" onClick={onClose}>
                Cancel
              </Button>

              <Button variant="contained" color="primary" type="submit">
                Create new case
              </Button>
            </ProgressIndicatorContainer>
          </DialogActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

CaseFormDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.bool
};
